module.exports = __webpack_public_path__ + "img/create_sign_wall.509af67b.png";